import Legend from "./Legend";

const TdDayHdg = ({ d }) => {
	return (
		<td className="center" style={{ width: "3.5%", fontSize: "0.9rem" }}>
			{d}
		</td>
	);
};

const TdDayVal = ({ status }) => {
	const i = status === 0 ? "fa-times" : "fa-hourglass-o";

	return (
		<td className="center" style={{ verticalAlign: "middle" }}>
			<span className={status === 0 ? "error" : "invisible"}>
				<div style={{ fontSize: "1rem", paddingTop: "4px" }}>
					<i className={`fa ${i}`}></i>
				</div>
			</span>
		</td>
	);
};

const Table2 = ({ type, text, data }) => {
	return (
		<table
			className="approved assigned"
			style={{ marginTop: "0", marginBottom: "25px" }}
		>
			<thead>
				<tr>
					<th colSpan="12" className="hdg">
						<p>{text}</p>
						<small style={{ fontWeight: "normal" }}>
							Hotel requests that could not be confirmed
						</small>

						<Legend type="unavailable" />
					</th>
				</tr>
			</thead>
			<thead>
				<tr>
					<td
						className="spot"
						rowSpan="2"
						style={{ width: "6%", paddingTop: "0", paddingBottom: "0" }}
					>
						ID
					</td>
					<td
						className="center"
						rowSpan="2"
						style={{ width: "37%", paddingTop: "0", paddingBottom: "0" }}
					>
						Occupant
					</td>
					<td
						className="center"
						rowSpan="2"
						style={{ paddingTop: "0", paddingBottom: "0" }}
					>
						Hotel / Room
					</td>

					<td className="center" colSpan="9">
						March 29 - April 6
					</td>
				</tr>
				<tr>
					<TdDayHdg d="S" />
					<TdDayHdg d="M" />
					<TdDayHdg d="T" />
					<TdDayHdg d="W" />
					<TdDayHdg d="T" />
					<TdDayHdg d="F" />
					<TdDayHdg d="S" />
					<TdDayHdg d="S" />
					<TdDayHdg d="M" />
				</tr>
			</thead>
			{data.length > 0 ? (
				<tbody>
					{data.map((item) => {
						return (
							<tr key={`${item.id}`}>
								<td className="spot">{item.id}</td>
								<td className="left">{item.occupant}</td>
								<td className="left">{item.hotel}</td>
								<TdDayVal status={item.sun1} />
								<TdDayVal status={item.mon1} />
								<TdDayVal status={item.tue1} />
								<TdDayVal status={item.wed1} />
								<TdDayVal status={item.thu1} />
								<TdDayVal status={item.fri1} />
								<TdDayVal status={item.sat1} />
								<TdDayVal status={item.sun2} />
								<TdDayVal status={item.mon2} />
							</tr>
						);
					})}
				</tbody>
			) : (
				<tbody>
					<tr>
						<td colSpan="12">
							<span className="working">-- no requests found --</span>
						</td>
					</tr>
				</tbody>
			)}
		</table>
	);
};

export default Table2;
